import { Suspense } from "react";
import loadable from "../../utils/loadable";
import withAemIntegration from "../../withAemIntegration";
const GlobalNavigation = loadable(() => import("@lexus.com/ui/dist/modules/GlobalNavigation/index.impl"));

const SkipMainContentComponent = loadable(() =>
  import("@lexus.com/ui/dist/components/SkipMainContentButton")
);

const HeaderEditConfig = {
  emptyLabel: "Header",
  isEmpty: (props) => !props || !props.title || props.title.trim().length < 1,
};

const Header = (props) => (
  <>
    <div id="header-module">
      <div className="pn" />
    </div>
    <SkipMainContentComponent />
    <Suspense>
      <GlobalNavigation {...props} />
    </Suspense>
  </>
);

export default withAemIntegration("lexus/components/header")(
  Header,
  HeaderEditConfig
);
